import axios from '@/axios'

export default {
  /**
   * Ask the in-BMS "Ask MediaMachine" assistant a question.
   * @param {string} question
   * @param {Array<{role:string, content:string}>} conversationHistory
   * @returns {Promise<{response:string, sources:string[], error:boolean}>}
   */
  ask(question, conversationHistory = []) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/cto/ask', { question, conversation_history: conversationHistory })
        .then(response => resolve(response.data))
        .catch(error => reject(error.response))
    })
  }
}
